import Loader from "@components/Loader";
import ModalConfirmation from "@components/ModalConfirmation";
import ModalFeatureProject from "@components/ModalFeatureProject";
import Table from "@components/Table";
import Title from "@components/Title";
import { EUiStates } from "@constants/enum";
import { downloadCSV } from "@helpers/csv.helper";
import useListColumns from "@hooks/Project/useListColumns";
import useListProject from "@hooks/Project/useListProject";
import useListItems from "@hooks/Shared/useListItems";
import listMapper from "@mappers/Modules/project/ListProject.mapper";
import getProjects from "@services/Project/getProjects";
import BanIcon from "mdi-react/AccountCancelOutlineIcon";
import { ReactElement } from "react";
import { Container } from "reactstrap";
import styles from "./ListProject.module.scss";

const ListItems = (): ReactElement => {
  const COLUMNS = useListColumns();
  const { isLoading, basicData, tableItems, getItems } = useListItems(
    getProjects,
    listMapper
  );

  const {
    isBanModalOpen,
    isFeatureModalOpen,
    handleBan,
    handleIsBanModalOpen,
    handleFeature,
    handleIsFeatureModalOpen,
  } = useListProject(basicData, getItems);

  if (isLoading) {
    return <Loader />;
  }

  return (
    <Container className={styles.listProject}>
      <ModalConfirmation
        icon={BanIcon}
        title="Projects | Ban confirmation"
        body={`Do you confirm to ${
          basicData?.banned ? "unban" : "ban"
        } the project:  "${basicData?.description}" ?`}
        handleConfirm={handleBan}
        handleModalStatus={handleIsBanModalOpen}
        modalStatus={isBanModalOpen}
        modalType={EUiStates.DANGER}
      />

      <ModalFeatureProject
        projectName={basicData?.description}
        modalStatus={isFeatureModalOpen}
        handleModalStatus={handleIsFeatureModalOpen}
        modalType={EUiStates.DANGER}
        handleConfirm={handleFeature}
      />

      <div className={styles.header}>
        <Title />
        <button
          className="btn-sm btn-danger btn btn-secondary"
          onClick={() =>
            downloadCSV(tableItems, "projects.csv", [
              "uuid",
              "name",
              "artist",
              "network",
              "projectType",
              "listingType",
              "status",
              "banned",
              "createdAt",
            ])
          }
        >
          Download
        </button>
      </div>
      <Table columns={COLUMNS} items={tableItems} />
    </Container>
  );
};

export default ListItems;
